import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labEditRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/$id/edit',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    tab: z
      .enum([
        'general',
        'team',
        'topics',
        'regions',
        'password',
        'expiredLabSetting',
        'stripeLabSettings',
        'payment',
        'legal_entity',
      ])
      .default('general'),
    paymentSubTab: z.enum(['paymentHistory', 'iban']).default('paymentHistory'),
  }),
}).lazy(() => import('pages/lab/Edit/LabEditPage/LabEditPage').then((d) => d.Route));
